module.exports = __webpack_public_path__ + "img/profileCancelled.0ea2a50d.svg";